export enum ChargePointStatus {
    Online = 'Online',
    Offline = 'Offline',
    Charging = 'Charging',
    Available = 'Available',
    Faulted = 'Faulted',
    Unavailable = 'Unavailable',
    Connected = 'Connected',
    Preparing = 'Preparing',
    SuspendedEV = 'SuspendedEV',
    SuspendedEVSE = 'SuspendedEVSE',
    Finishing = 'Finishing',
    Reserved = 'Reserved',
}
